import Button from 'components/Button';
import DownloadIcon from 'components/icons/Download';
import List from 'components/list';
import { BoldTd, Td } from 'components/list/Td';
import { Th } from 'components/list/Th';
import DOCUMENTATION_ROLE from 'enums/DocumentationRole';
import React, { FC, useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { setActiveColumns } from 'store/actions/admin/documentationFileLists';
import { StoreState } from 'store/reducers';
import { Action } from 'types/typeguards/reducerActions';
import downloadFile from 'utils/downloadFile';
import { DocumentationFilesContext } from '..';

export const columnNames = ['title', 'role'] as const;
export type ColumnNames = typeof columnNames[number];

export type Columns = {
  [key in ColumnNames]: boolean;
};

export const initialActiveColumns: Columns = {
  title: true,
  role: true,
};

type Props = {
  activeColumns: Columns;
};
const DocumentationFilesList: FC<Props> = ({ activeColumns }) => {
  const { files, pages, page, setPage, loading } = useContext(
    DocumentationFilesContext,
  );

  const columnNumber = useMemo(() => {
    let c = 1;
    Object.values(activeColumns).forEach((value) => {
      if (value) {
        c += 1;
      }
    });
    return c;
  }, [activeColumns]);

  const handleDownload = (id: number, filename: string) => {
    downloadFile(`/files/documentation-file/download/${id}`, filename);
  };

  return (
    <>
      <List
        activeColumns={activeColumns}
        columnNumber={columnNumber}
        isEmpty={files?.length === 0}
        emptyText="Aucun candidat n'est disponible pour cette recherche"
        pages={pages}
        page={page}
        setPage={setPage}
        placeCheckbox
        loading={loading}
      >
        <Th name="title">Titre</Th>
        <Th name="role">Type d'utilisateur</Th>
        <Th name="settings"></Th>
        {files?.map((documentationFile, idx) => (
          <React.Fragment key={idx}>
            <BoldTd name="title">
              <Link to={`${documentationFile.id}`}>
                {documentationFile.title}
              </Link>
            </BoldTd>
            <Td name="role">
              {documentationFile.role
                ? DOCUMENTATION_ROLE[documentationFile.role]
                : null}
            </Td>
            <Td name="settings">
              <Button
                color="primary"
                icon={<DownloadIcon />}
                onClick={() =>
                  handleDownload(
                    documentationFile.id || -1,
                    documentationFile.filename || 'fichier',
                  )
                }
              >
                Télécharger
              </Button>
            </Td>
          </React.Fragment>
        ))}
      </List>
    </>
  );
};

const mapStateToProps = (state: StoreState) => {
  return {
    activeColumns: state.admin.documentationFileLists.main.activeColumns,
  };
};

const mapDispatchToProps = (dispatch: (action: Action) => void) => {
  return {
    setActiveColumns: (activeColumns: Columns) =>
      dispatch(setActiveColumns<Columns>('main', activeColumns)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentationFilesList);
